import { render, staticRenderFns } from "./PlansChooser.vue?vue&type=template&id=3fb6a744&"
import script from "./PlansChooser.vue?vue&type=script&lang=js&"
export * from "./PlansChooser.vue?vue&type=script&lang=js&"
import style0 from "./PlansChooser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports